import { Box } from '@mui/material';
import { CountryDropdown, ValidatedTextInput } from '../../../../../common/inputs/ValidatedInputs';
import { forwardRef } from 'react';
import { withQueryData } from '../../../../../common/withQueryData';
import { useConfigurationData } from '../../../../../common/hooks/useConfigurationData';

const textFieldStyle = (editing) => {
    if (!editing) {
        return {
            '& .MuiOutlinedInput-root': {
                '& fieldset': { borderWidth: '0' },
            },
            '& .MuiInputLabel-root': {
                color: (theme) => `${theme.palette.text.secondary} !important`,
            },
            '& .MuiOutlinedInput-input': {
                WebkitTextFillColor: (theme) => `${theme.palette.text.primary} !important`
            },
            '& .MuiAutocomplete-endAdornment': {
                display: 'none'
            }
        }
    }
    else return null;
}

const CustomerDetails = forwardRef((props, ref) => {
    const { countriesQueryResults } = useConfigurationData();
    return <CustomerDetailsWrapperWithQueryData queryData={countriesQueryResults} {...props} />
})

const CustomerDetailsContent = ({ reservation, onChange, onError, editing, countries }) => {
    return <>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                <ValidatedTextInput
                    id='firstName'
                    value={reservation.firstName}
                    onChange={onChange}
                    label='First name'
                    disabled={!editing}
                    size='small'
                    sx={textFieldStyle(editing)}
                    required
                    InputLabelProps={{ required: editing }}
                />
                <ValidatedTextInput
                    id='lastName'
                    value={reservation.lastName}
                    onChange={onChange}
                    label='Last name'
                    disabled={!editing}
                    size='small'
                    sx={textFieldStyle(editing)}
                    required
                    InputLabelProps={{ required: editing }}
                />
            </Box>
            <ValidatedTextInput
                id='address'
                value={reservation.address}
                onChange={onChange}
                label='Address'
                disabled={!editing}
                size='small'
                sx={{
                    ...textFieldStyle(editing),
                    width: '400px'
                }}
                type='text'
                rows='2'
                multiline
                required
                InputLabelProps={{ required: editing }}
            />
            <Country
                selectedCountryCode={reservation.countryCode}
                onChange={onChange}
                countries={countries}
                editing={editing}

            />
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '10px' }}>
                    <ValidatedTextInput
                        size='small'
                        id='email'
                        onChange={onChange}
                        label='Email'
                        required
                        sx={{
                            ...textFieldStyle(editing),
                            width: '400px'
                        }}
                        value={reservation.email}
                        disabled={!editing}
                        email
                        InputLabelProps={{ required: editing }}
                    />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '10px' }}>
                    <CountryPrefix
                        value={reservation.countryPrefix}
                        onChange={onChange}
                        countries={countries}
                        editing={editing}
                    />
                    <ValidatedTextInput
                        size='small'
                        id='phoneNumber'
                        onChange={onChange}
                        label='Phone number'
                        required
                        sx={{
                            ...textFieldStyle(editing),
                            flexGrow: 1
                        }}
                        value={reservation.phoneNumber}
                        disabled={!editing}
                        phoneNumber
                        InputLabelProps={{ required: editing }}
                    />
                </Box>
            </Box>
        </Box>
    </>
}

const Country = ({ selectedCountryCode, onChange, editing, countries }) => {
    const selectedCountry = countries.find(country => country.code === selectedCountryCode);

    const onChangeCountry = (id, country, valid) => {
        onChange(id, country.code, valid);
    }

    return <CountryDropdown
        id='countryCode'
        value={selectedCountry}
        onChange={onChangeCountry}
        countries={countries}
        required
        disabled={!editing}
        textFieldProps={{
            label: 'Country',
            size: 'small',
            InputLabelProps: { required: editing }
        }}
        sx={{
            ...textFieldStyle(editing),
            width: '400px'
        }}
    />
}

const CountryPrefix = ({ value, onChange, editing, countries = [] }) => {
    const selectedCountryPrefix = countries.find(country => country.phonePrefix === value);

    const onChangeCountryPrefix = (id, country, valid) => {
        onChange(id, country.phonePrefix, valid);
    }

    return <CountryDropdown
        id='countryPrefix'
        value={selectedCountryPrefix}
        onChange={onChangeCountryPrefix}
        countries={countries}
        required
        disabled={!editing}
        textFieldProps={{
            label: 'Prefix',
            size: 'small',
            sx: {
                width: '135px'
            },
            InputLabelProps: { required: editing }
        }}
        sx={textFieldStyle(editing)}
        getOptionLabel={(country) => country.phonePrefix}
        getOptionText={(country) => `${country.phonePrefix} ${country.name}`}
        filterOptions={(countries, { inputValue }) => countries.filter(country => {
            return country.name.toLowerCase().includes(inputValue.toLowerCase()) || country.phonePrefix.toLowerCase().includes(inputValue.toLowerCase())
        })}
    />
}

const CustomerDetailsWrapper = ({ data, refetch, ...props }) => {
    return <CustomerDetailsContent countries={data} {...props} />
}

const CustomerDetailsWrapperWithQueryData = withQueryData(
    CustomerDetailsWrapper
)

export default CustomerDetails;